<template>
    <div class="nav-bar">
        <span class="back el-icon-arrow-left" @click="back"></span>
        <div class="title" v-html="navBarTitle"></div>
        <div class="subtitle" v-html="navBarSubtitle"></div>
    </div>
</template>
<script>
export default {
    name: 'NavBar',
    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        }
    },
    watch: {
        title: function(val, oldVal) {
            this.navBarTitle = val;
        },
        subtitle: function(val, oldVal) {
            this.navBarSubtitle = val;
        }
    },
    data() {
        return {
            navBarTitle: this.title,
            navBarSubtitle: this.subtitle
        };
    },
    mounted() {
    },
    methods: {
        back() {
            this.$router.go(-1);
        }
    }
};
</script>
<style lang="scss" scoped>
.nav-bar {
    height: 55px;
    padding: 0 62px;
    line-height: 1.3;
    background: #fff;
    color: #222831;
    border-bottom: 1px solid #eee;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    .back {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 60px;
        line-height: 55px;
        text-align: center;
        font-size: 20px;
        font-weight: 600;
    }
    .title {
        width: 100%;
        font-size: 16px;
        white-space: nowrap;
        text-align: center;
    }
    .subtitle {
        white-space: nowrap;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
        margin-top: 6px;
        font-size: 12px;
        text-align: center;
        color: #a2a4a8;
    }
}
</style>
